var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 1.66852V1.66602H16.665C17.125 1.66602 17.5 2.04518 17.5 2.49268V17.506C17.4998 17.7253 17.4125 17.9356 17.2574 18.0906C17.1022 18.2456 16.8918 18.3327 16.6725 18.3327H3.32752C3.21808 18.3319 3.10987 18.3096 3.00906 18.267C2.90825 18.2244 2.81681 18.1624 2.73997 18.0845C2.66313 18.0066 2.60239 17.9143 2.56122 17.8129C2.52005 17.7115 2.49925 17.603 2.50002 17.4935V6.66602L7.50002 1.66852ZM4.85835 6.66602H7.50002V4.02435L4.85835 6.66602ZM9.16669 3.33268V7.49935C9.16669 7.72036 9.07889 7.93232 8.92261 8.0886C8.76633 8.24488 8.55437 8.33268 8.33335 8.33268H4.16669V16.666H15.8334V3.33268H9.16669Z",
    fill: "#4F566B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.da4eeb2b.svg";
export { ForwardRef as ReactComponent };